/**
 * The compiler diagnostics that blocked issuing a beta-lane document
 * (`ir_document_has_errors`, ADR-0099), shown in the signing step so the
 * user sees what to fix without switching tabs.
 */

import type { IrDiagnostic } from '../api.js';

export function IrSigningDiagnostics({ diagnostics }: { diagnostics: ReadonlyArray<IrDiagnostic> }) {
  if (diagnostics.length === 0) return null;
  return (
    <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-800">
      <div className="font-medium">Åtgärda följande i fliken Avtal innan dokumentet kan skickas:</div>
      <ul className="mt-1.5 flex list-disc flex-col gap-0.5 pl-4">
        {diagnostics.map((d, i) => (
          <li key={`${d.code}-${d.instance_id ?? ''}-${d.slot_key ?? ''}-${i}`}>
            {d.message}
            <span className="ml-1 font-mono text-[10px] opacity-60">{d.code}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
